import InfoBox from '../InfoBox';

function ProgramFeedback({
    feedback,
    feedbackVisible,
    aktiviteterErApne,
    visPameldingStengtInfo,
    feedbackRef
}) {
    const shouldRender = feedback?.message || aktiviteterErApne || visPameldingStengtInfo;

    if (!shouldRender) return null;

    return (
        <div className="program-day__feedback" ref={feedbackRef}>
            {feedback?.message ? (
                <div
                    className={`program-day__feedback-inner ${
                        feedbackVisible ? 'is-visible' : 'is-hidden'
                    }`}
                >
                    <InfoBox variant={feedback.type}>
                        <p>{feedback.message}</p>
                    </InfoBox>
                </div>
            ) : aktiviteterErApne ? (
                <InfoBox variant="warning">
                    <p>Husk å lagre valgene dine for hver dag.</p>
                </InfoBox>
            ) : visPameldingStengtInfo ? (
                <InfoBox variant="info">
                    <p>
                        Påmeldingen til aktiviteter er nå stengt. Arrangøren går gjennom ønskene og
                        fordeler plasser der det er mulig. Du vil få beskjed når du kan logge inn
                        igjen og se endelig resultat.
                    </p>
                </InfoBox>
            ) : null}
        </div>
    );
}

export default ProgramFeedback;
